import { withWindow } from '@shared/utils/withWindow';
import type { CommandMenuSource } from './AdminCommandMenu.types';

export const isMac = withWindow(w => /Mac|iPhone|iPad|iPod/i.test(w.navigator.userAgent), false);

export const shortcutLabel = isMac ? '⌘K' : 'Ctrl+K';

/**
 * Tracks how and where the command menu was opened so telemetry can
 * distinguish keyboard shortcuts, the dashboard search bar, and the
 * header-bar search button.
 *
 * `trigger` maps to Open-event trigger; `source` is propagated to all
 * events in the session.
 */
type OpenContext = Readonly<{ trigger: 'keyboard' | 'button'; source: CommandMenuSource }>;

let nextOpenContext: OpenContext = { trigger: 'keyboard', source: 'keyboard' };

export function setNextOpenTrigger(trigger: 'keyboard' | 'button', source: CommandMenuSource) {
  nextOpenContext = { trigger, source };
}

export function consumeNextOpenTrigger(): OpenContext {
  const ctx = nextOpenContext;
  nextOpenContext = { trigger: 'keyboard', source: 'keyboard' };
  return ctx;
}
